export default __webpack_public_path__ + "static/media/96.8daccb60.jpg";